const words = ["Confort", "Discrétion", "Élégance", "Transferts Aéroport", "Longue Distance", "24H/24 · 7J/7"];

const Marquee = () => (
  <div data-testid="marquee" className="relative border-y border-white/5 bg-ink-800 py-6 overflow-hidden">
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center" aria-hidden={k === 1}>
          {words.map((w, i) => (
            <span key={`${k}-${i}`} className="flex items-center">
              <span className="px-8 font-serif italic text-3xl sm:text-4xl text-blush/40">{w}</span>
              <span className="text-rose/60">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
